import { render, staticRenderFns } from "./AboutUsFaq.vue?vue&type=template&id=80074bf0&scoped=true"
import script from "./AboutUsFaq.vue?vue&type=script&lang=js"
export * from "./AboutUsFaq.vue?vue&type=script&lang=js"
import style0 from "./AboutUsFaq.vue?vue&type=style&index=0&id=80074bf0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80074bf0",
  null
  
)

export default component.exports